var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddtocart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8425 14.6667H9.68517L7.5025 6.66667H23.8425L19.8425 14.6667ZM26.1105 5.264C25.6212 4.472 24.7732 4 23.8425 4H6.77584L5.95317 0.982667C5.7945 0.402667 5.26784 0 4.6665 0H1.99984C1.2625 0 0.666504 0.597333 0.666504 1.33333C0.666504 2.06933 1.2625 2.66667 1.99984 2.66667H3.64784L7.37984 16.3507C7.5385 16.9307 8.06517 17.3333 8.6665 17.3333H20.6665C21.1718 17.3333 21.6332 17.048 21.8598 16.596L26.2278 7.85867C26.6452 7.02533 26.5998 6.056 26.1105 5.264ZM8.0001 20C6.8961 20 6.0001 20.8947 6.0001 22C6.0001 23.1053 6.8961 24 8.0001 24C9.1041 24 10.0001 23.1053 10.0001 22C10.0001 20.8947 9.1041 20 8.0001 20ZM19.3334 22C19.3334 20.8947 20.2294 20 21.3334 20C22.4374 20 23.3334 20.8947 23.3334 22C23.3334 23.1053 22.4374 24 21.3334 24C20.2294 24 19.3334 23.1053 19.3334 22Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtocart);
export default __webpack_public_path__ + "static/media/addtocart.8ef8083fbfe6462e7990875c9784aed8.svg";
export { ForwardRef as ReactComponent };